import { render, staticRenderFns } from "./CompanyNotesManagement.vue?vue&type=template&id=4c418f01&scoped=true&"
import script from "./CompanyNotesManagement.vue?vue&type=script&lang=js&"
export * from "./CompanyNotesManagement.vue?vue&type=script&lang=js&"
import style0 from "./CompanyNotesManagement.vue?vue&type=style&index=0&id=4c418f01&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c418f01",
  null
  
)

export default component.exports